import { getRawTextFromCellContentString } from '../../../../common/table/utils/tableCellContentStringUtils';

import type { CellData, HotComputedCellValue } from '../../../../common/table/TableTypes';
import { once } from 'lodash';

type GetCellRenderValue = (cellData: CellData, locale: string, hotComputedCellValue: HotComputedCellValue) => string;

let getCellRenderValue: GetCellRenderValue | undefined;

/** Registers the cell renderer once the lazy table runtime has loaded. */
export const registerGetCellRenderValue = (getter: GetCellRenderValue): void => {
    getCellRenderValue = getter;
};

const warnUnregistered = once(() => {
    console.warn('Cell renderer is not registered yet, falling back to raw value.');
});

export const getTableCellSearchValue = (cellData: CellData | undefined, locale: string): string | number => {
    if (!cellData || !cellData.value) return '';

    if (!cellData.type && cellData.resultValue === undefined) {
        return getRawTextFromCellContentString(cellData.value);
    }

    if (!getCellRenderValue) {
        // Cell renderer is not registered yet, fallback to raw value.
        // This shouldn't happen - when a board with tables is opened it should load the runtime straight away
        warnUnregistered();
        return cellData.resultValue ?? cellData.value;
    }

    return getCellRenderValue(cellData, locale, cellData.resultValue ?? null);
};
